import { DEFAULT_SECTION_CONTENT_PROPERTIES } from './SectionProperties';
import { ContentFragmentType } from './Content';
import { ColumnLayout } from './layouts';
import { createGuid } from '../../api/public/utils/Guid';
export const ContentSectionHelper = {
    build: (id, layout, columns, properties) => ({
        _id: id,
        type: ContentFragmentType.Section,
        value: {
            columnLayout: layout,
            columns,
            properties,
        },
    }),
    createNew: (layout, columns) => ContentSectionHelper.build(createGuid(), layout, columns, DEFAULT_SECTION_CONTENT_PROPERTIES),
    createOneColumnSectionFromExisting: (columnId, section) => ContentSectionHelper.build(createGuid(), ColumnLayout.SingleColumn, [columnId], { ...section.value.properties }),
    isSection: (fragment) => fragment.type === ContentFragmentType.Section,
};
